import { CartUpdateError } from './cartBadRequestError';

// List of error messages to ignore
const ignoringRequests = ['[BFF] Error reaching payment processor'];

/**
 * Determines whether the error should be ignored based on the error message for PaymentDeclinedAlert handle the error.
 * @param error - The error object
 * @returns boolean - True if the error should be ignored, false otherwise
 */
export const getShouldIgnorePaymentError = (error?: unknown): boolean => {
    if (error instanceof CartUpdateError && error.errorDetails?.detail) {
        const includesIgnoringMessage = ignoringRequests.includes(error.errorDetails.detail);

        return includesIgnoringMessage;
    }

    return false;
};
